export const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat("en-US");
  const formattedNumber = formatter.format(value);
  return formattedNumber;
};
